
export const creator = {
  hero: {
    title: "Építsd fel digitális jelenleted",
    subtitle: "Egyszerű platform tartalomgyártóknak",
    description: "Készíts személyes oldalt, értékesíts digitális termékeket, és építs közösséget."
  },
  benefits: {
    title: "Miért válassz minket?",
    subtitle: "Minden, amire egy tartalomgyártónak szüksége van",
    items: [
      {
        title: "Egyszerű beállítás",
        description: "Percek alatt elkészítheted a saját oldaladat, technikai tudás nélkül."
      },
      {
        title: "Testreszabható megjelenés",
        description: "Minden részletet a saját ízlésedhez igazíthatsz."
      },
      {
        title: "Több bevételi forrás",
        description: "Digitális termékek, személyre szabott videók, konzultációk és még több lehetőség."
      },
      {
        title: "Elemzések és statisztikák",
        description: "Kövesd nyomon tartalmaaid teljesítményét és növeld a bevételeidet."
      }
    ],
    freedom: {
      title: "Kreatív szabadság",
      description: "Fejezd ki magad korlátozások vagy platformkorlátok nélkül."
    },
    revenue: {
      title: "Többféle bevételi forrás",
      description: "Keress a tartalomértékesítéssel, konzultációkkal és személyre szabott szolgáltatásokkal."
    },
    immediate: {
      title: "Azonnali eredmények",
      description: "Kezdj el keresni, amint a profilod be van állítva és jóváhagyva."
    },
    secure: {
      title: "Biztonságos fizetések",
      description: "Minden tranzakció biztonságosan, ipari szabványú védelemmel történik."
    },
    cta: "Kezdd el még ma"
  },
  newsletter: {
    title: "Iratkozz fel hírlevelünkre",
    subtitle: "Elsőként értesülj a legújabb funkciókról",
    placeholder: "Add meg az email címed",
    button: "Feliratkozás",
    successMessage: "Sikeres feliratkozás!"
  }
};
